import { OrderType } from "@cede/types";
import { useTabsFactory } from "@/store";

export const tradeTabs = [
  { value: OrderType.LIMIT, label: "Limit", disabled: false },
  { value: OrderType.MARKET, label: "Market", disabled: false },
];

export const useTradeTabs = useTabsFactory(tradeTabs);
